import { Box, Typography, Divider } from "@mui/material";
import CommunityStatItem from "./CommunityStatItem";

const CommunityStats = ({ dataByRegion }) => 
    <>
    {Object.entries(dataByRegion).map(([region, communities], index) => (
        <Box key={index} sx={{ mb: 0.5 }}>
        <Typography variant="h6" sx={{ mb: 0.5, color: "#2563eb" }}>
            {region}
        </Typography>
        <Box sx={{ pl: 0, pb:0, maxHeight: "300px", overflowY: "auto" }}>
            {communities.map((community, idx) => (
            <Box
                key={idx}
                sx={{
                mb: 1,
                display: "flex",
                flexDirection: "column",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                padding: "8px",
                backgroundColor: "#fff",
                }}
            >
                <CommunityStatItem community={community} />
            </Box>
            ))}
        </Box>
        <Divider sx={{ my: 1 }} />
        </Box>
    ))}
    </>


export default CommunityStats;

